<template>
  <base-page-component>
    <div>
      <span class="text-danger" v-for="item in validateErrors.items" v-bind:key="item.id">
        {{ `#${item.id}: ${item.msg}`}}
        <br />
      </span>
    </div>
          <div>
      <b-row>

        <b-modal ref="editAccountNumModal" hide-footer title="Edit Account Number" data-backdrop="static" data-keyboard="false">
  <template #modal-title>
     <span>Edit Account Number</span>
     <span class="close-modal" @click="hideEditAccountNumModal()">×</span>
  </template>
  <div class="d-block text-center">
    <h3>Account Number</h3>
    <p v-if="updateAccountNumErrMsg" class="errMsg">{{ updateAccountNumErrMsg }}</p>
    <b-form-input v-model="updatedAccountNum" :maxlength="15" minlength="5" @keydown="filterNonAlphanumeric" required placeholder="New Account Number"></b-form-input>
  </div>
  <b-button class="mt-3" variant="outline-success" :disabled="IsEditAccountNumButtDisabled" block @click="editAccountNumSubmit($event)">Save</b-button>
  <b-button class="mt-2" variant="outline-danger" block @click="hideEditAccountNumModal()">Cancel</b-button>
</b-modal>


        <b-col md="12">
          <b-card>
            <div slot="header">
              <strong>{{accountName}}</strong>
              <small>#{{accountNumber}} </small>
              <b-btn @click="ViewLog" class="btn btn-default pull-right ml-2">
                <i title="ViewLog" class="fa fa-archive fa-lg text-white"></i> <strong class="text-white">
                  View
                  Log
                </strong>
              </b-btn>
              <b-btn @click="saveAccount" class="btn btn-success pull-right ml-2">
                <i title="Back" class="fa fa-floppy-o fa-lg text-white"></i> <strong class="text-white">
                  Save
                  All
                </strong>
              </b-btn>
              <b-btn @click="Cancel" class="btn btn-warning pull-right ml-2">
                <i title="Back" class="fa fa-undo fa-lg text-white"></i> <strong class="text-white">Cancel</strong>
              </b-btn>
            </div>
            <div id="divAccount" v-if="account">

              <b-row>
                <b-col lg="6" v-show="SectionRoleAccess('CompanyInfo').visible">
                  <!--v-show="role=='Admin' || role=='User' "-->
                  <b-card>
                    <div slot="header">
                      <strong>Company</strong>
                      <small>Info</small>
                    </div>
                    <b-row>
                      <b-col lg="6">
                        <b-form-group>
                          <div class="row">
                          <div class="col-auto">
                            <label>Account #</label>
                          </div>
                          <div class="col">
                            <div v-on:click="showEditAccountNumModal"  class="fa fa-pencil float-right accountEdit"></div>
                          </div>
                        </div>
                        <div class="list-group">
                          <div class="list-group-item">{{ account.AccountNumber }}</div>
                        </div>
                        </b-form-group>
                      </b-col>
                      <b-col lg="6">
                        <b-form-group>
                          <label>Dealership ID</label>
                          <div class="list-group">
                            <div class="list-group-item">{{ account.ID }}</div>
                          </div>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col lg="12">
                        <b-form-group>
                          <label for="name">Name</label>
                          <b-form-input type="text" v-model="account.Name" placeholder="Company name" :disabled="!SectionRoleAccess('CompanyInfo').enabled"></b-form-input>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col lg="12">
                        <b-form-group>
                          <label for="address">Address</label>
                          <b-form-input type="text" v-model="account.Address" placeholder="Address" :disabled="!SectionRoleAccess('CompanyInfo').enabled" :class="{'alert-danger': invalidAddress}"></b-form-input>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col lg="3">
                        <b-form-group>
                          <label for="ddCity">City</label>
                          <b-form-input type="text" v-model="account.City" placeholder="City" :disabled="!SectionRoleAccess('CompanyInfo').enabled" :class="{'alert-danger': invalidAddress}"></b-form-input>
                        </b-form-group>
                      </b-col>
                      <b-col lg="3">
                        <b-form-group v-if="IsCanadaProvince">
                          <label for="ddState">Province</label>
                          <b-form-select id="ddState" v-model="account.State" required :disabled="!SectionRoleAccess('CompanyInfo').enabled" :class="{'alert-danger': invalidAddress}">
                            <option v-for="(option, name) in provinceOptions" :value="name" v-bind:key="name">
                              {{ name }} -
                              {{ option }}
                            </option>
                          </b-form-select>
                        </b-form-group>
                        <b-form-group v-if="IsCanadaProvince===false">
                          <label for="ddState">State</label>
                          <b-form-select id="ddState" v-model="account.State" required :disabled="!SectionRoleAccess('CompanyInfo').enabled" :class="{'alert-danger': invalidAddress}">
                            <option v-for="(option, name) in stateOptions" :value="name" v-bind:key="name">
                              {{ name }} -
                              {{ option }}
                            </option>
                          </b-form-select>
                        </b-form-group>
                      </b-col>
                      <b-col lg="3">
                        <b-form-group v-if="countryCode.value === '1'">
                          <label for="ddZip">Zip Code</label>
                          <b-form-input type="text" v-model="account.Zip" placeholder="Zip Code" :disabled="!SectionRoleAccess('CompanyInfo').enabled" :class="{'alert-danger': invalidAddress}"></b-form-input>
                        </b-form-group>
                        <b-form-group v-else>
                          <label for="ddZip">Postal Code</label>
                          <b-form-input type="text" v-model="account.Zip" placeholder="Postal Code" :disabled="!SectionRoleAccess('CompanyInfo').enabled" :class="{'alert-danger': invalidAddress}"></b-form-input>
                        </b-form-group>
                      </b-col>
                      <b-col lg="4">
                        <b-form-group>
                          <label for="ddCountry">Country</label>
                          <b-dropdown v-model="countryCode" v-bind:key="countryCode.value" no-caret variant="outline-secondary" style="height:35px; background-color: #ffffff !important;" class="mr-2 d-flex justify-content-between">
                            <template v-slot:button-content>
                              <div class="d-flex justify-content-between">
                                <div v-if="countryCode.value==='1'" style="color: #000000 !important;">
                                  <img src="../assets/icons8-usa-96.png" class="flagImage" /> USA
                                </div>
                                <div v-if="countryCode.value==='2'" style="color: #000000 !important;">
                                  <img src="../assets/icons8-canada-96.png" class="flagImage"/> CANADA
                                </div>
                                <div v-if="countryCode.value==='0'" style="color: #000000 !important;">
                                </div>
                                <div style="width:15px;float:right;">
                                  <i class="fa fa-caret-down"></i>
                                </div>
                              </div>
                            </template>
                            <b-dropdown-item
                              :disabled="countryCodeOptions.disabled"
                              @click="selectCountryCode(option)"
                              v-for="option in countryCodeOptions" v-bind:key="option.value" style="width:200px !important;">
                              <div>
                                <img v-if="option.src !== undefined" :src="option.src" class="flagImage">
                                {{option.text}}
                              </div>
                            </b-dropdown-item>
                          </b-dropdown>
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </b-card>
                  <b-card>
                    <b-row class="mb-2 d-flex">

                      <b-btn @click="mDriveCalc" class="btn btn-warning ml-2" v-show="role=='Admin' || role=='User'">
                        <i title="mDriveCalculate" class="fa fa-car fa-lg text-white"></i> <strong class="text-white">
                          Calculate mDrive
                        </strong>
                      </b-btn>

                      <b-input-group class="ml-auto w-50">

                        <b-form-select :options="availableActionKeys"
                                       text-field="CreatedTS"
                                       value-field="actionkey"
                                       v-model="selectedActionKey">
                        </b-form-select>
                        <b-input-group-append>
                          <b-btn @click="mDriveRollback" class="btn btn-warning ml-auto" v-show="role=='Admin' || role=='User'">
                            <i title="mDriveCalculate" class="fa fa-car fa-lg text-white"></i> <strong class="text-white">
                              Roll Back mDrive
                            </strong>
                          </b-btn>
                        </b-input-group-append>
                      </b-input-group>

                    </b-row>
                    <b-row class=" d-flex">

                      <b-btn v-bind:href="'https://mportal.marketscan.com/web/index.html#/login?redirect=mdrivewizard&account='+accountNumber+''" class="btn btn-secondary ml-2">
                        <i title="mDriveWizard" class="fa fa-magic fa-lg text-white"></i> <strong class="text-white">
                          mDrive Wizard
                        </strong>
                      </b-btn>

                      <b-btn @click="DeleteInventory()" class="btn btn-danger ml-auto" v-show="role=='Admin' || role=='User'">
                        <i title="DeleteInventory" class="fa fa-trash fa-lg text-white"></i>
                        <strong class="text-white">Delete Inventory</strong>
                      </b-btn>

                    </b-row>
                  </b-card>
                </b-col>
                <b-col lg="6" v-show="SectionRoleAccess('AccountSettings').visible">
                  <b-card>
                    <div slot="header">
                      <strong>Account</strong>
                      <small>Settings</small>
                      <dx-switch id="accDisabled" switchedOffText="Enabled" switchedOnText="Disabled" class="pull-right"
                                 width="80px" v-model="account.Disabled" :disabled="!SectionRoleAccess('AccountSettings').enabled"></dx-switch>
                    </div>
                    <b-row>
                      <b-col lg="4">
                        <b-form-group>
                          <label for="ccnumber">Maximum Users</label>
                          <b-form-input type="number" v-model="account.Subscription.MaxUsers" @keydown="filterNonAlphanumeric"
                                        placeholder="Max Users" :disabled="!SectionRoleAccess('AccountSettings').enabled"></b-form-input>
                        </b-form-group>
                      </b-col>
                      <b-col lg="4">
                        <b-form-group>
                          <label for="ccnumber">Maximum Simil. Users</label>
                          <b-form-input type="number" v-model="account.Subscription.MaxSimultaniousUsers" @keydown="filterNonAlphanumeric"
                                        placeholder="Max Simil. Users" :disabled="!SectionRoleAccess('AccountSettings').enabled"></b-form-input>
                        </b-form-group>
                      </b-col>
                      <b-col lg="4">
                        <b-form-group>
                          <label for="ccnumber">Max Scans</label>
                          <b-form-input type="number" v-model="account.Subscription.MaxScans" @keydown="filterNonAlphanumeric"
                                        placeholder="Max Scans" :disabled="!SectionRoleAccess('AccountSettings').enabled"></b-form-input>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col lg="4">
                        <b-form-group>
                          <label for="account.mScanAPIStatus">Account Status</label><br />
                          <b-form-select id="ddAccountStatus" v-model="AccountStatus" required :disabled="!SectionRoleAccess('AccountSettings').enabled">
                            <option value="0">Live</option>
                            <option value="1">Beta</option>
                            <option value="2">Internal</option>
                          </b-form-select>
                          <div v-if="AccountStatus === 1">
                            <div>
                              <label for="BetaEndDate">Beta End Date:</label>
                            </div>
                            <div>
                              <dx-date-box v-model="account.BetaEndDate" :disabled="!SectionRoleAccess('AccountSettings').enabled"></dx-date-box>
                            </div>
                          </div>
                        </b-form-group>
                      </b-col>
                      <b-col lg="8">
                        <b-form-group>
                          <label for="year1">Customer Type</label>
                          <div id="basicInlineCustomCheckboxes" role="group">
                            <b-form-checkbox v-model="account.Subscription.RecurrentPayer" :disabled="!SectionRoleAccess('AccountSettings').enabled">
                              Recurring Customer
                            </b-form-checkbox>
                            <div class="custom-control-inline">
                              <label for="day1" style="width:125px;">Billing Start Day:</label>
                              <b-form-select style="width:75px;" v-model="account.Subscription.BillingCycleDay"
                                             :plain="true"
                                             :options="[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31]"
                                             :disabled="!SectionRoleAccess('AccountSettings').enabled">
                              </b-form-select>
                            </div>
                            <b-form-checkbox v-model="account.IsmScanAPIOnly" :disabled="!SectionRoleAccess('AccountSettings').enabled">mScan API only</b-form-checkbox>
                          </div>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col lg="4">
                        <b-form-group>
                          <label for="expDate">Cutoff Date</label>
                          <dx-date-box v-model="account.Subscription.ExpirationDate" :disabled="!SectionRoleAccess('AccountSettings').enabled"></dx-date-box>
                        </b-form-group>
                      </b-col>
                      <b-col lg="2">
                        <b-form-group>
                          <b-row>
                            <label for="EnterpriseBool">Enterprise</label>
                          </b-row>
                          <b-row>
                            <dx-switch v-model="isEnterpriseEnabled" :disabled="!SectionRoleAccess('AccountSettings').enabled"></dx-switch>
                          </b-row>
                        </b-form-group>
                      </b-col>
                      <b-col lg="4">
                        <b-form-group v-show="isEnterpriseEnabled">
                          <b-row>
                            <label for="EnterpriseName">Enterprise Name</label>
                          </b-row>
                          <b-row>
                            <b-form-select class="mr-2" id="ddEnterpriseName" v-model="enterpriseId" :options="enterpriseList" value-field="EnterpriseId" text-field="Name" />
                          </b-row>
                          <b-row>
                          <label for="EnterpriseName"><BR/>(It is recommended to only affiliate with enterprises in the same country.)</label>
                          </b-row>
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </b-card>
                  <b-card>
                    <b-btn v-on:click="ResetAdminPassword" :disabled="!SectionRoleAccess('AccountSettings').enabled">Reset Admin Password</b-btn>
                    <b-btn v-on:click="ResetEULA" :disabled="!SectionRoleAccess('AccountSettings').enabled">Force EULA Request</b-btn>
                  </b-card>
                </b-col>
              </b-row>
              <b-row>
                <b-col class="manage-links" lg="12" v-show="SectionRoleAccess('ManageLinks').visible">
                  <b-card>
                    <div slot="header">
                      <strong>Manage Links</strong>
                    </div>
                    <b-row>
                        <b-col class="manage-links-section quoting-policies" lg="4" v-show="SectionRoleAccess('ManageLinks').visible">
                          <AccountManageLinkItem
                          :title="'Quoting Policies'"
                          :manageDealershipLinkSubscriptionType="DealershipLinkSubscriptionType.QuotingRules"
                          :physicalDealershipKey="account_physical_dealership_key"
                          :accountNumber="account.AccountNumber"
                          :dealershipId="account.ID"
                          :dealershipLink="GetDealershipLinkByType(DealershipLinkSubscriptionType.QuotingRules)"
                          :dealershipsByCurrentPhysicalDealershipKey = "GetEligibleDealershipsToLinkByType(DealershipLinkSubscriptionType.QuotingRules)"
                          :hasPaddingTop="true"
                          :onError="handleError"
                          @refreshData="fetchData" />
                        </b-col>
                        <b-col class="manage-links-section inventory" lg="4" v-show="SectionRoleAccess('ManageLinks').visible">
                          <AccountManageLinkItem
                          :title="'Inventory'"
                          :descriptor="'Inventory Settings'"
                          :manageDealershipLinkSubscriptionType="DealershipLinkSubscriptionType.Inventory"
                          :physicalDealershipKey="account_physical_dealership_key"
                          :dealershipId="account.ID"
                          :dealershipLink="GetDealershipLinkByType(DealershipLinkSubscriptionType.Inventory)"
                          :dealershipsByCurrentPhysicalDealershipKey = "GetEligibleDealershipsToLinkByType(DealershipLinkSubscriptionType.Inventory)"
                          :accountNumber="account.AccountNumber"
                          :hasPaddingTop="true"
                          :onError="handleError"
                          @refreshData="fetchData" />
                        </b-col>
                        <b-col class="manage-links-section other-settings" lg="4" v-show="SectionRoleAccess('ManageLinks').visible">
                          <AccountManageLinkItem
                          :title="'Other Settings'"
                          :manageDealershipLinkSubscriptionType="DealershipLinkSubscriptionType.CalculationSettings" :physicalDealershipKey="account_physical_dealership_key"
                          :dealershipId="account.ID"
                          :dealershipLink="GetDealershipLinkByType(DealershipLinkSubscriptionType.CalculationSettings)"
                          :dealershipsByCurrentPhysicalDealershipKey = "GetEligibleDealershipsToLinkByType(DealershipLinkSubscriptionType.CalculationSettings)"
                          :accountNumber="account.AccountNumber"
                          description="*Other Settings Includes: Dealer Defined Fees, Lenders, Rate Markup, Acquisition Fee Markup,
                              Rate Markup Extended, Calculation Settings, Market Specific Settings,
                              Rebate Regions, Parts & Service Tax Settings."
                          :onError="handleError"
                          @refreshData="fetchData"/>
                        </b-col>
                      </b-row>
                  </b-card>
                </b-col>
              </b-row>
              <b-row>
                <b-col lg="6" v-show="SectionRoleAccess('Features').visible">
                  <b-card>
                    <div class="row" slot="header">
                      <b-col class="col-sm-2 minWidthFeatureLabel"><strong>Features</strong></b-col>
                    </div>
                    <div style="height: 350px; overflow: auto">
                      <table aria-busy="false" aria-colcount="3"
                             class="table b-table table-striped table-bordered table-sm">
                        <tbody>
                          <tr v-for="f in account.Subscription.Features" v-bind:key="f.Name">
                            <td aria-colindex="1">{{ f.Name }}</td>
                            <td aria-colindex="2">
                              <dx-switch v-model="f.IsSelected" @value-changed="changedFeatureState(f)" :disabled="!SectionRoleAccess('Features').enabled || ShouldDisableFlatFileInventoryDownload(f.Name)"></dx-switch>
                            </td>
                            <td aria-colindex="3">
                              <table aria-busy="false" aria-colcount="2" class="table table-features table-sm"
                                     style="margin:0;">
                                <tbody>
                                  <tr>
                                    <td aria-colindex="1">
                                      <div role="group" class="input-group">
                                        <dx-date-box v-model="f.DateStart" placeholder="Date Start" :disabled="!SectionRoleAccess('Features').enabled || ShouldDisableFlatFileInventoryDownload(f.Name)"></dx-date-box>
                                      </div>
                                    </td>
                                    <td aria-colindex="2">
                                      <div role="group" class="input-group">
                                        <dx-date-box v-model="f.DateEnd" placeholder="Date End" :disabled="!SectionRoleAccess('Features').enabled || ShouldDisableFlatFileInventoryDownload(f.Name)"></dx-date-box>
                                      </div>
                                    </td>
                                  </tr>
                                  <tr v-for="fp in f.Properties" v-bind:key="fp.Name">
                                    <td aria-colindex="1">
                                      <div role="group" class="input-group">
                                        <div class="input-group-prepend">
                                          <div class="input-group-text"><i class="fa fa-tag"></i></div>
                                        </div>
                                        <b-form-textarea type="text"
                                                         v-model="fp.Name"
                                                         :title="fp.Name"
                                                         :rows="2"
                                                         :max-rows="2"
                                                         no-resize
                                                         readonly
                                                         disabled
                                                         style="background-color:initial; border:none;"></b-form-textarea>
                                      </div>
                                    </td>
                                    <td aria-colindex="2">
                                      <b-form-input v-if="fp.Type!=1" type="text" v-model="fp.Value" :disabled="!SectionRoleAccess('Features').enabled || ShouldDisableFlatFileInventoryDownload(f.Name)"></b-form-input>
                                      <dx-switch v-if="fp.Type==1" data-feature-code="f.FEATURE_PROPERTY_ID" v-model="fp.Value" :disabled="!SectionRoleAccess('Features').enabled || ShouldDisableFlatFileInventoryDownload(f.Name)"></dx-switch>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </b-card>
                </b-col>
                <b-col lg="6" v-show="SectionRoleAccess('DMSCSVFieldMapping').visible">
                  <b-card>
                    <div class="row" slot="header">
                      <b-col class="col-sm-4 vertical-center"><strong>DMS CSV Field Mapping</strong></b-col>
                      <b-col class="col-sm-8 text-right"><b-btn v-on:click="$refs['dmsImportAccountModal'].show()" :disabled="!SectionRoleAccess('DMSCSVFieldMapping').enabled || this.GetDealershipLinkByType(DealershipLinkSubscriptionType.Inventory) != null">Import From Account</b-btn></b-col>
                    </div>
                    <div style="height: 350px; overflow: auto">
                      <table aria-busy="false" aria-colcount="3"
                             class="table b-table table-striped table-bordered table-sm">
                        <tbody>
                          <tr v-for="f in account.Subscription.InventoryCSVFields" v-bind:key="f.ID">
                            <td aria-colindex="1">{{ f.Description }}</td>
                            <td aria-colindex="2">
                              <b-form-input type="text" data-feature-code="f.ID" v-model="f.Value" :disabled="!SectionRoleAccess('DMSCSVFieldMapping').enabled || GetDealershipLinkByType(DealershipLinkSubscriptionType.Inventory) != null"></b-form-input>
                            </td>
                            <td aria-colindex="3" v-show="SectionRoleAccess('DMSCSVFieldMapping').enabled">
                              <div style="padding-top:5px;">
                                <c-switch v-if="f.CanOverride" data-feature-code="f.ID" v-model="f.Override"
                                          type="default"
                                          variant="primary-outline-alt" title="Override" :disabled="GetDealershipLinkByType(DealershipLinkSubscriptionType.Inventory) != null" />
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </b-card>
                </b-col>
                <b-modal id="dms-import-account-modal" title="Import DMS Mappings" ref="dmsImportAccountModal" hide-footer>
                  <label>Import DMS Mappings From Account ID: </label>
                  <div v-if="dmsModalError">
                    <span class="text-danger">Account not found</span>
                  </div>
                  <b-form-input type="text" v-model="dmsAccountIdImportInput" @keydown.native="OnImportDMSKeydown"></b-form-input>
                  <span class="text-danger font-italic">*Make sure to click Save All on account page to persist mappings.</span>
                  <div class="dms-modal-btn-container">
                    <b-btn class="modal-import-btn" variant="primary" v-on:click="ImportDMSMappingsFromAccountId" :disabled="dmsAccountIdImportInput == null || dmsAccountIdImportInput <= 0">Import</b-btn>
                    <b-btn class="modal-cancel-btn" variant="light" v-on:click="OnImportModalCancel">Cancel</b-btn>
                  </div>
                </b-modal>
              </b-row>
              <b-row>
                <b-col lg="3" v-show="SectionRoleAccess('States').visible">
                  <b-card>
                    <div slot="header">
                      <strong>States</strong>
                    </div>
                    <div style="padding:-10px 0 10px 0;" v-show="SectionRoleAccess('States').enabled">
                      <a href="javascript:void(0)" @click="selectAllStates(true)">Select All</a> | <a href="javascript:void(0)" @click="selectAllStates(false)">
                        Unselect
                        All
                      </a>
                    </div>
                    <div style="height: 200px; overflow: auto">
                      <b-form-checkbox-group stacked :plain="true" v-model="account.Subscription.RegionsSelected"
                                             :checked="account.Subscription.RegionsSelected">
                        <b-form-checkbox v-for="r in account.Subscription.Regions" :value="r.ID" v-bind:key="r.ID" :disabled="!SectionRoleAccess('States').enabled">
                          {{ r.Code }} - {{ r.Name }}
                        </b-form-checkbox>
                      </b-form-checkbox-group>
                    </div>
                  </b-card>
                </b-col>
                <b-col lg="3" v-show="SectionRoleAccess('LeaseLenderRegions').visible">
                  <b-card>
                    <div slot="header">
                      <strong>Lease Lender Regions</strong>
                    </div>
                    <div v-show="SectionRoleAccess('LeaseLenderRegions').enabled">
                      <a href="javascript:void(0)" @click="selectAllLeaseRegions(true)"
                         v-show="SectionRoleAccess('LeaseLenderRegions').enabled">Select All</a> | <a href="javascript:void(0)" @click="selectAllLeaseRegions(false)">Unselect All</a>
                    </div>

                    <div style="height: 200px; overflow: auto">
                      <b-form-checkbox-group stacked :plain="true"
                                             v-model="account.Subscription.LeaseLenderRegionsSelected"
                                             :checked="account.Subscription.LeaseLenderRegionsSelected">
                        <b-form-checkbox v-for="l in account.Subscription.LeaseLenderRegions" :value="l.ID"
                                         v-bind:key="l.ID" :disabled="!SectionRoleAccess('LeaseLenderRegions').enabled">
                          {{ l.Lender }}: {{l.Region}}
                        </b-form-checkbox>
                      </b-form-checkbox-group>
                    </div>
                  </b-card>
                </b-col>
                <b-col lg="3" v-show="SectionRoleAccess('RetailLenderRegions').visible">
                  <b-card>
                    <div slot="header">
                      <strong>Retail Lender Regions</strong>
                    </div>
                    <div v-show="SectionRoleAccess('RetailLenderRegions').enabled">
                      <a href="javascript:void(0)" @click="selectAllRetailRegions(true)">Select All</a> | <a href="javascript:void(0)" @click="selectAllRetailRegions(false)">Unselect All</a>
                    </div>

                    <div style="height: 200px; overflow: auto">
                      <b-form-checkbox-group stacked :plain="true"
                                             v-model="account.Subscription.RetailLenderRegionsSelected"
                                             :checked="account.Subscription.RetailLenderRegionsSelected">
                        <b-form-checkbox v-for="l in account.Subscription.RetailLenderRegions" :value="l.ID"
                                         v-bind:key="l.ID" :disabled="!SectionRoleAccess('RetailLenderRegions').enabled">
                          {{ l.Lender }}: {{l.Region}}
                        </b-form-checkbox>
                      </b-form-checkbox-group>
                    </div>
                  </b-card>
                </b-col>
                <b-col lg="3" v-show="SectionRoleAccess('SubscribedMakes').visible">
                  <b-card>
                    <div slot="header">
                      <strong>Subscribed Makes</strong>
                    </div>
                    <!--<a href="javascript:void(0)" @click="selectAllMakes(true)">Select All</a> | <a href="javascript:void(0)"
                                                                                                   @click="selectAllMakes(false)">
                      Unselect
                      All
                    </a>-->
                    <div style="height: 200px; overflow: auto">

                      <slot v-for="m in account.Subscription.Makes">
                        <slot v-if="m.ID === 0 && SectionRoleAccess('RetailLenderRegions').enabled">
                          <b-form-checkbox :value="m.ID" v-bind:key="m.ID" @change="makeselected($event)" :plain="true"
                                           v-model="account.Subscription.MakesSelected" :disabled="!SectionRoleAccess('SubscribedMakes').enabled">
                            {{  m.Name }}
                          </b-form-checkbox>
                          <!--<a href="javascript:void(0)" @click="selectAllMakes(true)">Select All</a> |
                          <a href="javascript:void(0)" @click="selectAllMakes(false)"> Unselect All </a>-->
                        </slot>
                        <slot v-else>
                          <b-form-checkbox-group stacked :plain="true" v-model="account.Subscription.MakesSelected" :disabled="allMakesSelected"
                                                 :checked="account.Subscription.MakesSelected">

                            <b-form-checkbox :value="m.ID" v-bind:key="m.ID" :disabled="!SectionRoleAccess('SubscribedMakes').enabled">
                              {{  m.Name }}
                            </b-form-checkbox>
                          </b-form-checkbox-group>
                        </slot>
                      </slot>
                    </div>
                  </b-card>
                </b-col>
              </b-row>
              <b-row>
                <b-col lg="12" md="12" sm="12" xs="12" v-show="SectionRoleAccess('Notes').visible">
                  <b-card>
                    <div slot="header">
                      <strong>Notes</strong>
                      <small>Section</small>
                      <b-btn @click="saveDealershipNotes" class="btn btn-success pull-right ml-2" :disabled="!SectionRoleAccess('Notes').enabled">
                        <i title="Save" class="fa fa fa-sticky-note-o fa-lg text-white"></i> <strong class="text-white">
                          Save Note
                        </strong>
                      </b-btn>
                    </div>
                    <b-row class="mb-2">
                      <b-form-textarea id="txtNote"
                                       v-model="txtNote"
                                       placeholder="Enter note..."
                                       rows="3" :disabled="!SectionRoleAccess('Notes').enabled"></b-form-textarea>
                    </b-row>
                    <b-row>
                      <b-col md="9" class="my-0">
                        <b-form-group class="my-1">
                          <b-input-group>
                            <!--v-on:keyup.esc="ClearSearch"-->
                            <span class="mr-2">Filter by: </span>
                            <b-form-input class="mr-2" v-model="Keyword" placeholder="Keyword" :disabled="!SectionRoleAccess('Notes').enabled" />
                            <b-input-group-append>
                              <b-btn class="btn btn-default text-white mr-2" @click="ClearSearch" :disabled="!SectionRoleAccess('Notes').enabled">
                                <i class="fa fa-eraser" title="Clear Search"></i> <strong class="text-white">Clear all</strong>
                              </b-btn>
                              <b-btn class="btn btn-warning text-white mr-2" @click="getDealershipNotes" :disabled="!SectionRoleAccess('Notes').enabled">
                                <i class="fa fa-search" title="Search"></i> <strong class="text-white">Search</strong>
                              </b-btn>
                            </b-input-group-append>
                          </b-input-group>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-table :items="notes" :fields="noteFields" hover striped bordered small :current-page="currentPage"
                               :per-page="perPage" show-empty>

                        <template slot="CREATED_TS" slot-scope="row">
                          {{ row.item.CREATED_TS | formatDate }}
                        </template>
                        <template slot="PIN_BY" slot-scope="row">
                          <span v-if="row.item.DEALERSHIP_NOTE_PIN_ID > 0">
                            <b-link @click="unpin(row.item.DEALERSHIP_NOTE_ID)" :disabled="!SectionRoleAccess('Notes').enabled">
                              <i class="fa fa-star text-warning ml-1" aria-hidden="true"></i>
                            </b-link>
                          </span>
                          <span v-if="row.item.DEALERSHIP_NOTE_PIN_ID == 0">
                            <b-link @click="pin(row.item.DEALERSHIP_NOTE_ID)" :disabled="!SectionRoleAccess('Notes').enabled">
                              <i class="fa fa-star text-info ml-1" aria-hidden="true"></i>
                            </b-link>
                          </span>
                        </template>
                      </b-table>

                    </b-row>
                    <div slot="footer">
                      <b-link @click="ViewNotes" class="pull-right ml-2" :disabled="!SectionRoleAccess('Notes').enabled">
                        More notes . . .
                      </b-link>
                    </div>
                  </b-card>
                </b-col>
              </b-row>
              <b-row>
                <b-col lg="6" v-show="SectionRoleAccess('IPFiltering').visible">
                  <b-card>
                    <div slot="header">
                      <strong>IP Filtering</strong>
                    </div>
                    <div style="height: 350px; overflow: auto">
                      <table aria-busy="false" aria-colcount="3"
                             class="table b-table table-striped table-bordered table-sm">
                        <thead>
                          <tr>
                            <th aria-colindex="1">ID</th>
                            <th aria-colindex="2">IP Start</th>
                            <th aria-colindex="3">IP End</th>
                            <th aria-colindex="4" width="180px">
                              <b-btn @click="AddIPAddress" class="btn btn-success ml-2" :disabled="!SectionRoleAccess('IPFiltering').enabled">
                                <i title="ViewLog" class="fa fa-plus fa-lg text-white"></i> <strong class="text-white">
                                  Add
                                  IP Address
                                </strong>
                              </b-btn>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="ipEntry in account.Subscription.IPAddresses" v-bind:key="ipEntry.ID">
                            <td aria-colindex="1">{{ ipEntry.ID }}</td>
                            <td aria-colindex="2">
                              <!--
                              <b-form-input type="text" data-feature-code="ipEntry.IPStart" v-model="ipEntry.IPStart"></b-form-input>
                              -->
                              <dx-text-box v-model="ipEntry.IPStart"
                                           v-validate="{required: true, validateIPaddress: true}"
                                           v-bind:name="`IPStart ${ipEntry.ID}`"
                                           :isValid="HasError(`IPStart ${ipEntry.ID}`)"
                                           :validationError="GetError(`IPStart ${ipEntry.ID}`)" :disabled="!SectionRoleAccess('IPFiltering').enabled" />
                            </td>
                            <td aria-colindex="3">
                              <!--<b-form-input type="text" data-feature-code="ipEntry.IPEnd"
                              v-model="ipEntry.IPEnd"></b-form-input>-->
                              <dx-text-box v-model="ipEntry.IPEnd"
                                           v-validate="{required: false, validateIPaddress: true}"
                                           v-bind:name="`IPEnd ${ipEntry.ID}`"
                                           :isValid="HasError(`IPEnd ${ipEntry.ID}`)"
                                           :validationError="GetError(`IPEnd ${ipEntry.ID}`)" :disabled="!SectionRoleAccess('IPFiltering').enabled" />
                            </td>
                            <td aria-colindex="4">
                              <b-btn @click="DeleteIPAddress(ipEntry.ID)" class="btn btn-danger ml-2" :disabled="!SectionRoleAccess('IPFiltering').enabled">
                                <i title="Back" class="fa fa-trash fa-lg text-white"></i> <strong class="text-white">Delete</strong>
                              </b-btn>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </b-card>
                </b-col>
                <b-col lg="6">
                  <b-card>
                    <div slot="header">
                      <b-row>
                        <b-col class="col-sm-8"><strong>mDesking - Pop-up</strong></b-col>
                        <b-col class="col-sm-4">
                          <b-btn @click="fetchReceivedDeals()" class="btn btn-smaller btn-success pull-right ml-2"><i title="RefreshPopUps" class="fa fa-undo text-white"></i></b-btn>
                        </b-col>
                      </b-row>
                    </div>
                    <div style="height: 350px; overflow: auto; word-break: break-all">
                      <table aria-busy="false" aria-colcount="4" class="table b-table table-striped table-bordered table-sm">
                        <thead>
                          <tr>
                            <th aria-colindex="1" width="145px">Created Time</th>
                            <th aria-colindex="2">Title</th>
                            <th aria-colindex="3" width="100px">User</th>
                            <th aria-colindex="4" width="180px">
                              <b-btn @click="DeleteAllPopUps()" class="btn btn-small btn-danger ml-2">
                                <i title="DeleteAllPopUps" class="fa fa-trash fa-lg text-white"></i> <strong class="text-white">Delete All</strong>
                              </b-btn>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="mQEvent in receivedDeals" v-bind:key="mQEvent.mQEventID">
                            <td aria-colindex="1">{{ mQEvent.CreatedTC }}</td>
                            <td aria-colindex="2">{{ mQEvent.Greeting }}</td>
                            <td aria-colindex="3">{{ mQEvent.Name }}</td>
                            <td aria-colindex="4">
                              <b-btn @click="DeletePopUp(mQEvent.UserID, mQEvent.mQEventID)" class="btn btn-small btn-danger ml-2">
                                <i title="DeletePopUp" class="fa fa-trash fa-lg text-white"></i> <strong class="text-white">Delete</strong>
                              </b-btn>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </b-card>
                </b-col>
              </b-row>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </base-page-component>
</template>

<script>
import axios from 'axios'
import store from '@/store'
import cSwitch from '../components/Switch'
import {basePageMixin} from '@/mixins/basePageMixin'
import {DxTextBox} from 'devextreme-vue'
import DxSelectBox from 'devextreme-vue/select-box'
import {Validator} from 'vee-validate'
import moment from 'moment'
import {DxSwitch} from 'devextreme-vue/ui/switch'
import {
  DxDateBox,
  DxCalendarOptions,
  DxDisplayFormat
} from 'devextreme-vue/ui/date-box'
import deepdiff from 'deep-diff'
import css1 from 'devextreme/dist/css/dx.common.css'
import css2 from 'devextreme/dist/css/dx.light.css'
import usImage from '../assets/icons8-usa-96.png'
import caImage from '../assets/icons8-canada-96.png'
import AccountManageLinkItem from '../components/Account/AccountManageLinkItem.vue'
import DealershipLinkSubscriptionType from '../enums/DealershipLinkSubscriptionType'

const validateIPaddress = {
  getMessage (field, params, data) {
    return `You should provide a valid IP address for ${field}`
  },
  validate (value, args) {
    // console.log(`validate: ${value} : args ${args}`)
    if (/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(value)) {
      return true
    }
    return false
  }
}

Validator.extend('validateIPaddress', validateIPaddress)

export default {
  components: {
    cSwitch,
    DxDateBox,
    DxCalendarOptions,
    DxDisplayFormat,
    DxSwitch,
    DxTextBox,
    DxSelectBox,
    AccountManageLinkItem
  },
  mixins: [basePageMixin],
  data () {
    return {
      dpConfig: {
        format: 'MM/DD/YYYY',
        useCurrent: false,
      },
      updatedAccountNum: '',
      updateAccountNumErrMsg: '',
      role: 'User',
      makes: ['ACURA', 'ALFA_ROMEO', 'AUDI', 'BENTLEY', 'BMW', 'BUICK', 'CADILLAC', 'CHEVROLET', 'CHRYSLER', 'DODGE', 'FIAT', 'FORD', 'GENESIS', 'GMC', 'HONDA', 'HYUNDAI', 'INFINITI', 'JAGUAR', 'JEEP', 'KIA', 'LAND_ROVER', 'LEXUS', 'LINCOLN', 'MASERATI', 'MAZDA', 'MERCEDES-BENZ', 'MINI', 'MITSUBISHI', 'NISSAN', 'PORSCHE', 'RAM', 'SMART_CAR', 'SUBARU', 'TOYOTA', 'VOLKSWAGEN', 'VOLVO'],
      dmsFields: [{key: 'feature', label: 'Feature'}, {key: 'ftID', label: 'Enabled'}, {key: 'override'}],
      retailLenders: [],
      arr: [],
      accountOriginal: undefined,
      isPrimaryAccount: false,
      isInventoryEnabled: false,
      account: undefined,
      account_physical_dealership_key: null,
      dealershipLinks: [],
      dealershipsByCurrentPhysicalDealershipKey: [],
      receivedDeals: [],
      availableActionKeys: [],
      selectedActionKey: '',
      currentPage: 1,
      perPage: 12,
      totalRows: 0,
      Keyword: '',
      txtNote: '',
      allMakesSelected: false,
      enterpriseList: undefined,
      isEnterpriseEnabled: false,
      invalidAddress: false,
      enterpriseName: '',
      enterpriseId: '',
      invDeleteConfirmCount: 0,
      dmsModalError: null,
      dmsAccountIdImportInput: null,
      notes: [],
      noteFields: [
        { key: 'PIN_BY', label: 'Pin', tdClass: 'pin_by_column_css' },
        { key: 'CREATED_TS', label: 'Created', sortable: true, tdClass: 'created_ts_column_css'},
        { key: 'CREATED_BY', label: 'Created_By', sortable: true, tdClass: 'create_by_column_css'},
        { key: 'DESCRIPTION', label: 'Description', sortable: true }
      ],
      associatedDealershipsToPrimaryFields: [
        { key: 'NAME', label: 'Name', tdClass: 'pin_by_column_css', sortable: true },
        { key: 'DEALERSHIP_ID', label: 'Dealership ID', tdClass: 'pin_by_column_css', sortable: true },
        { key: 'ACCOUNT_NUMBER', label: 'Account #', tdClass: 'pin_by_column_css', sortable: true }
      ],
      stateOptions: {
        'AL': 'Alabama',
        'AK': 'Alaska',
        'AS': 'American Samoa',
        'AZ': 'Arizona',
        'AR': 'Arkansas',
        'CA': 'California',
        'CO': 'Colorado',
        'CT': 'Connecticut',
        'DE': 'Delaware',
        'DC': 'District Of Columbia',
        'FM': 'Federated States Of Micronesia',
        'FL': 'Florida',
        'GA': 'Georgia',
        'GU': 'Guam',
        'HI': 'Hawaii',
        'ID': 'Idaho',
        'IL': 'Illinois',
        'IN': 'Indiana',
        'IA': 'Iowa',
        'KS': 'Kansas',
        'KY': 'Kentucky',
        'LA': 'Louisiana',
        'ME': 'Maine',
        'MH': 'Marshall Islands',
        'MD': 'Maryland',
        'MA': 'Massachusetts',
        'MI': 'Michigan',
        'MN': 'Minnesota',
        'MS': 'Mississippi',
        'MO': 'Missouri',
        'MT': 'Montana',
        'NE': 'Nebraska',
        'NV': 'Nevada',
        'NH': 'New Hampshire',
        'NJ': 'New Jersey',
        'NM': 'New Mexico',
        'NY': 'New York',
        'NC': 'North Carolina',
        'ND': 'North Dakota',
        'MP': 'Northern Mariana Islands',
        'OH': 'Ohio',
        'OK': 'Oklahoma',
        'OR': 'Oregon',
        'PW': 'Palau',
        'PA': 'Pennsylvania',
        'PR': 'Puerto Rico',
        'RI': 'Rhode Island',
        'SC': 'South Carolina',
        'SD': 'South Dakota',
        'TN': 'Tennessee',
        'TX': 'Texas',
        'UT': 'Utah',
        'VT': 'Vermont',
        'VI': 'Virgin Islands',
        'VA': 'Virginia',
        'WA': 'Washington',
        'WV': 'West Virginia',
        'WI': 'Wisconsin',
        'WY': 'Wyoming'
      },
      FormRolePermissions: [{
        role: 'PM',
        sections: [
          {
            section: 'CompanyInfo',
            visible: true,
            enabled: false
          },
          {
            section: 'AccountSettings',
            visible: true,
            enabled: false
          },
          {
            section: 'Features',
            visible: false,
            enabled: false
          },
          {
            section: 'DMSCSVFieldMapping',
            visible: false,
            enabled: false
          },
          {
            section: 'States',
            visible: true,
            enabled: true
          },
          {
            section: 'LeaseLenderRegions',
            visible: true,
            enabled: true
          },
          {
            section: 'RetailLenderRegions',
            visible: true,
            enabled: true
          },
          {
            section: 'SubscribedMakes',
            visible: true,
            enabled: true
          },
          {
            section: 'Notes',
            visible: true,
            enabled: true
          },
          {
            section: 'IPFiltering',
            visible: false,
            enabled: false
          }
        ]
      }],
      provinceOptions: {
        'AB': 'Alberta',
        'BC': 'British Columbia',
        'MB': 'Manitoba',
        'NB': 'New Brunswick',
        'NL': 'Newfoundland and Labrador',
        'NT': 'Northwest Territories',
        'NS': 'Nova Scotia',
        'NU': 'Nunavut',
        'ON': 'Ontario',
        'PE': 'Prince Edward Island',
        'QC': 'Quebec',
        'SK': 'Saskatchewan',
        'YT': 'Yukon'
      },
      provinceOptionsArray: [
        {'Code': 'AB', 'Name': 'Alberta'},
        {'Code': 'BC', 'Name': 'British Columbia'},
        {'Code': 'MB', 'Name': 'Manitoba'},
        {'Code': 'NB', 'Name': 'New Brunswick'},
        {'Code': 'NL', 'Name': 'Newfoundland and Labrador'},
        {'Code': 'NT', 'Name': 'Northwest Territories'},
        {'Code': 'NS', 'Name': 'Nova Scotia'},
        {'Code': 'NU', 'Name': 'Nunavut'},
        {'Code': 'ON', 'Name': 'Ontario'},
        {'Code': 'PE', 'Name': 'Prince Edward Island'},
        {'Code': 'QC', 'Name': 'Quebec'},
        {'Code': 'SK', 'Name': 'Saskatchewan'},
        {'Code': 'YT', 'Name': 'Yukon'}
      ],
      countryCodeOptions: [
        {
          value: '0',
          text: '',
          src: undefined
        },
        {
          value: '1',
          text: 'USA',
          src: usImage
        },
        {
          value: '2',
          text: 'CANADA',
          src: caImage
        }
      ],
      countryCode: undefined
    }
  },
  created () {
    let self = this
    self.role = store.state.currentRole
    self.countryCode = self.countryCodeOptions[0]
    self.fetchData()
  },
  filters: {
    formatDate: function (date) {
      var m = moment(date)
      if (m.isValid()) {
        return m.add(moment().utcOffset(), 'm').format('MM/DD/YYYY hh:mm:ss a')
      }
      return ''
    },
    formatAccessDisplay: function (accessBool) {
      var display = 'No'
      if (accessBool) {
        display = 'Yes'
      }
      return display
    }
  },
  methods: {
    filterNonAlphanumeric(event) {
      const key = event.key;
      // Check if the pressed key is alphanumeric or a navigation key (e.g., arrow keys, delete, etc.)
      if (!/^[a-zA-Z0-9]$/i.test(key) && !['Backspace', 'ArrowLeft', 'ArrowRight', 'Delete', 'Home', 'End'].includes(key)) {
        // Prevent the default action (e.g., typing the character) for non-alphanumeric keys
        event.preventDefault();
      }
    },
    hideEditAccountNumModal(){
      this.$refs['editAccountNumModal'].hide()
    },
    showEditAccountNumModal(){
      this.updatedAccountNum = this.account.AccountNumber
      this.$refs['editAccountNumModal'].show()
    },
    async editAccountNumSubmit(event) {
      //prevent modal from auto-closing when clicking "OK"
      event.preventDefault();
      this.toggleloader(true)
      let requestObj = {
           account: this.getAccountForSave(),
           updatedAccountNum: this.updatedAccountNum
      }

      try {

        var response = await axios.post('/api/accounts/updateaccountnum', requestObj);
        this.$router.push('/account/'+this.updatedAccountNum)

        if (this.account.PrimaryAccount.AccountNumber === this.account.AccountNumber) {
          this.account.PrimaryAccount.AccountNumber = this.updatedAccountNum
        }
        this.account.AccountNumber = this.updatedAccountNum
        this.fetchData() //make sure all data on page is updated

        this.$refs['editAccountNumModal'].hide()
        this.showNotification(response.data.message);
      } catch (error) {
        if (error.response.status == 409 || error.response.status == 400) {
          this.updateAccountNumErrMsg = error + " - " + error.response.data.message
        }
        else {
          this.updateAccountNumErrMsg = "An error occured attempting to update the account number."
        }
      }
      this.toggleloader(false)
    },
    SectionRoleAccess (section) {
      let self = this
      if (store.state.currentRole !== 'Admin' || store.state.currentRole !== 'User') {
        let rolePermisions = self.FormRolePermissions.filter(x => x.role === store.state.currentRole)
        if (rolePermisions.length > 0) {
          let sectionpermission = rolePermisions[0].sections.filter(x => x.section == section)
          if (sectionpermission.length > 0) { return sectionpermission[0] }
        }
      }
      return {
        visible: true,
        enabled: true
      }
    },
    GetError (param) {
      let self = this
      let err = self.validateErrors.first(param)
      // console.log(`GetError: ${err} for '${param}'`)
      if (err !== undefined) {
        return {message: err}
      }
      return undefined
    },
    HasError (param) {
      let self = this
      if (self.validateErrors.first(param) !== undefined) {
        // console.log(`HasError: NO for '${param}'`)
        return false
      }
      // console.log(`HasError: YES for '${param}'`)
      return true
    },
    AddIPAddress (id) {
      let self = this
      self.account.Subscription.IPAddresses.unshift({'ID': 0, 'IPStart': '', 'IPEnd': ''})
    },
    DeleteIPAddress (id) {
      let self = this
      self.account.Subscription.IPAddresses = self.account.Subscription.IPAddresses.filter(r => r.ID !== id)
    },
    ViewLog () {
      let self = this
      self.$router.push({name: 'AccountAudit', params: {accountId: self.account.AccountNumber}})
    },
    ViewNotes () {
      let self = this
      self.$router.push({name: 'AccountViewNotes', params: {accountId: self.account.AccountNumber}})
    },
    mDriveCalc () {
      let self = this
      let calcStatus = ''
      let message = 'Calculate mDrive for this account?'

      if (self.account.Subscription.Features.find(x => x.Name === 'mDrive').IsSelected === false) {
        self.showNotification('Please toggle mDrive in the features section before calculating mDrive.')
        return
      }

      if (self.SubscriptionIsExpired()) {
        self.showNotification('Account is past cutoff date.')
        return
      }

      let options = {
        html: true, // set to true if your message contains HTML tags. eg: "Delete <b>Foo</b> ?"
        loader: false, // set to true if you want the dailog to show a loader after click on "proceed"
        reverse: false, // switch the button positions (left to right, and vise versa)
        okText: 'Continue',
        cancelText: 'Close',
        animation: 'zoom', // Available: "zoom", "bounce", "fade"
        type: 'basic', // 'basic', // coming soon: 'soft', 'hard'
        verification: 'I know better', // for hard confirm, user will be prompted to type this to enable the proceed button
        verificationHelp: 'Type "[+:verification]" below to confirm', // Verification help text. [+:verification] will be matched with 'options.verification' (i.e 'Type "continue" below to confirm')
        clicksCount: 3, // for soft confirm, user will be asked to click on "proceed" btn 3 times before actually proceeding
        backdropClose: false, // set to true to close the dialog when clicking outside of the dialog window, i.e. click landing on the mask
        customClass: '' // Custom class to be injected into the parent node for the current dialog instance
      }

      axios.get('/api/accounts/mDriveGetStatus?account=' + self.account.AccountNumber)
        .then(response => {
          calcStatus =
              message = '<b>Status</b><br>' + response.data + '<br><br>' + message
          self.$dialog.confirm(message, options)
            .then(function () {
              self.toggleloader(true)
              axios.get('/api/accounts/mDriveCalcAccount?account=' + self.account.AccountNumber)
                .then(response2 => {
                  self.showNotification('mDrive calculation started')
                })
                .catch(error2 => {
                  self.showError('There was an error processing your request')
                }).then(r2 => {
                  self.toggleloader(false)
                })
            })
        })
        .catch(error => {
          self.showNotification('There is currently another account being processed.')
        }).then(r => {
          self.toggleloader(false)
        })
    },
    SubscriptionIsExpired () {
      let self = this

      var s = self.account.Subscription.ExpirationDate

      if (s) {
        const s2 = s.split('T')[0]

        var date = s2.split('-')
        var year = parseInt(date[0])
        var month = parseInt(date[1])
        var day = parseInt(date[2])

        var today = new Date()
        var today_day = parseInt(String(today.getDate()).padStart(2, '0'))
        var today_month = parseInt(String(today.getMonth() + 1).padStart(2, '0'))
        var today_year = parseInt(today.getFullYear())

        if ((today_year > year) || (today_year === year && today_month > month) || (today_year === year && today_month === month && today_day > day)) {
          return true
        }
      }
      return false
    },
    async GetEligibleDealershipsToLink () {
      var request = { AccountNumber: this.account.AccountNumber, DealershipId: this.account.ID }

      var response = await axios.post('/api/accounts/geteligibledealershipstolink', request)
        .catch(error => {
          this.$emit('onError', error)
        })

      return response.data
    },
    GetDealershipLinkByType (type) {
      if (!this.dealershipLinks || this.dealershipLinks.length == 0) {
        return null
      }

      return this.dealershipLinks.find(x => x.DealershipLinkSubscriptionTypeId == type)
    },
    GetEligibleDealershipsToLinkByType (type) {
      if (!this.dealershipsByCurrentPhysicalDealershipKey) {
        return null
      }

      return this.dealershipsByCurrentPhysicalDealershipKey.filter(x => x.DealershipLinkSubscriptionTypeId == type)
    },
    ShouldDisableFlatFileInventoryDownload (sectionName) {
      return sectionName == 'Flat File Invt. Download' && this.GetDealershipLinkByType(DealershipLinkSubscriptionType.Inventory) != null
    },
    mDriveRollback () {
      let self = this
      let actionkey
      console.log(self.selectedActionKey)
      if (!self.selectedActionKey) { actionkey = self.availableActionKeys[0].actionkey } else { actionkey = self.selectedActionKey }

      if (!actionkey) { return }

      axios.get('/api/accounts/mDriveRollbackAccount?account=' + self.account.AccountNumber + '&actionkey=' + actionkey)
        .then(response => {
          self.showNotification('mDrive Rolled Back')
        })
        .catch(error => {
          self.showNotification('Something went wrong rolling back mDrive: ' + error)
        })
    },
    changedFeatureState (f) {
      let self = this

      if (f.Code === 'DMSFTP') {
        self.isInventoryEnabled = f.IsSelected
      }

      if (f.Name === 'mDrive' && f.IsSelected) {
        f.Properties.find(x => x.Name === 'Push Deal to Webhook').Value = f.IsSelected
        self.account.Subscription.Features.find(x => x.Name === 'Customers').IsSelected = f.IsSelected
        self.account.Subscription.Features.find(x => x.Name === 'Inventory').IsSelected = f.IsSelected
        self.account.Subscription.Features.find(x => x.Name === 'New Vehicle Retail').IsSelected = f.IsSelected
        self.account.Subscription.Features.find(x => x.Name === 'New Vehicle Lease').IsSelected = f.IsSelected
        self.account.Subscription.Features.find(x => x.Name === 'Used Vehicle Lease').IsSelected = f.IsSelected
        self.account.Subscription.Features.find(x => x.Name === 'Used Vehicle Retail').IsSelected = f.IsSelected
        self.account.Subscription.Features.find(x => x.Name === 'Flat File Invt. Download').IsSelected = f.IsSelected
        self.account.Subscription.Features.find(x => x.Name === 'Market Scan Rebates').IsSelected = f.IsSelected
        self.account.Subscription.Features.find(x => x.Name === 'mScanAPI Integration').IsSelected = f.IsSelected
      }
    },
    async deleteEnterprise () {
      let obj = {
        DealershipID: this.account.ID
      }
      this.toggleloader(true)
      try {
        await axios.post('/api/enterprise/deleteenterpriseaccount', obj)
      } catch (error) {
        this.handleError(error)
      } finally {
        this.toggleloader(false)
      }
    },
    async addEnterprise () {
      let self = this
      let obj = {
        DealershipID: this.account.ID,
        EnterpriseId: this.enterpriseId
      }

      try {
        this.toggleloader(true)
        await axios.post('/api/enterprise/addenterpriseaccount', obj)
      } catch (error) {
        this.handleError(error)
      } finally {
        self.toggleloader(false)
      }
    },
    fetchData () {
      let self = this

      axios.get('/api/accounts/loadaccount?a=' + self.$route.params.accountId)
        .then(async response => {
          let info = response.data

          // info['swAPIEnv'] = info.mScanAPIStatus === 0
          // info["BetaEndDate"] = new Date()
          self.account = info
          self.accountOriginal = JSON.parse(JSON.stringify(self.account))
          if (self.account.Country !== undefined && self.account.Country !== null) {
            if (self.account.Country === 2) {
              self.countryCode = self.countryCodeOptions[2]
            } else if (self.account.Country === 1) {
              self.countryCode = self.countryCodeOptions[1]
            } else {
              self.countryCode = self.countryCodeOptions[0]
            }
          } else {
            if (self.IsCanada) {
              self.countryCode = self.countryCodeOptions[2]
            } else {
              self.countryCode = self.countryCodeOptions[1]
            }
          }

          self.SetBooleans(self.account)
          self.getDealershipNotes()
          if (self.account.Subscription.MakesSelected.indexOf(0) >= 0) {
            self.allMakesSelected = true
            var list = [0]
            self.account.Subscription.MakesSelected = list
          }

          if (self.account.Subscription.Features.find(x => x.Code === 'DMSFTP').IsSelected === true) {
            self.isInventoryEnabled = true
          }

          self.fetchReceivedDeals()
          self.fetchEnterpriseData(response.data.PartnerIdInt)
          self.fetchmDriveActionKeys()

          self.dealershipLinks = response.data.DealershipLinks
          self.account_physical_dealership_key = response.data.Physical_Dealership_Key

          if (self.account_physical_dealership_key) {
            this.dealershipsByCurrentPhysicalDealershipKey = await this.GetEligibleDealershipsToLink()
          }
        })
        .catch(error => {
          self.handleError(error)
        }).then(r => {
          self.toggleloader(false)
        })
    },
    async fetchEnterpriseData (partnerIdInt) {
      this.toggleloader(true)

      try {

        let args = {
          'PartnerIdInt': partnerIdInt
        }

        let response = await axios.post('/api/enterprise/getenterprisenames', args)
        this.enterpriseList = response.data
        await this.fetchCurrentEnterprise()
      } catch (error) {
        this.handleError(error)
      } finally {
        this.toggleloader(false)
      }
    },

    async fetchCurrentEnterprise () {
      let obj = {
        AccountNumber: this.account.AccountNumber
      }

      let response = await axios.post('/api/enterprise/getcurrententerprise', obj)
      let enterpriseId = response.data

      if (enterpriseId != '') {
        this.enterpriseId = enterpriseId
        this.isEnterpriseEnabled = true
      }
    },
    fetchReceivedDeals () {
      let self = this
      axios.get('/api/accounts/LoadmQEvents?dealershipid=' + self.account.ID)
        .then(response => {
          let info = response.data
          self.receivedDeals = info
        })
        .catch(error => {
          self.handleError(error)
        }).then(r => {
          self.toggleloader(false)
        })
    },
    fetchmDriveActionKeys () {
      let self = this
      axios.get('/api/accounts/mDriveGetLastRuns?account=' + self.account.AccountNumber)
        .then(response => {
          let info = response.data
          self.availableActionKeys = info
          // console.log(self.availableActionKeys)
        })
        .catch(error => {
          self.showNotification('Something went wrong getting action keys: ' + error)
        })
    },
    SetBooleans (accountOriginal) {
      accountOriginal.Subscription.Features.forEach(feature => {
        if (feature.Properties != null) {
          feature.Properties.forEach(property => {
            if (property.Type == 1) {
              if (property.Value == 'True') {
                property.Value = true
              } else {
                property.Value = false
              }
            }
          })
        }
      })
    },
    ResetAdminPassword () {
      let self = this

      let message = 'Are you sure you would like to reset Admin Password?'
      let options = {
        html: false, // set to true if your message contains HTML tags. eg: "Delete <b>Foo</b> ?"
        loader: false, // set to true if you want the dailog to show a loader after click on "proceed"
        reverse: false, // switch the button positions (left to right, and vise versa)
        okText: 'Continue',
        cancelText: 'Close',
        animation: 'zoom', // Available: "zoom", "bounce", "fade"
        type: 'basic', // 'basic', // coming soon: 'soft', 'hard'
        verification: 'I know better', // for hard confirm, user will be prompted to type this to enable the proceed button
        verificationHelp: 'Type "[+:verification]" below to confirm', // Verification help text. [+:verification] will be matched with 'options.verification' (i.e 'Type "continue" below to confirm')
        clicksCount: 3, // for soft confirm, user will be asked to click on "proceed" btn 3 times before actually proceeding
        backdropClose: false, // set to true to close the dialog when clicking outside of the dialog window, i.e. click landing on the mask
        customClass: '' // Custom class to be injected into the parent node for the current dialog instance
      }

      let obj = {
        dealershipId: self.account.ID,
        accountNumber: self.account.AccountNumber
      }

      self.$dialog.confirm(message, options)
        .then(function () {
          self.toggleloader(true)
          axios.post('/api/accounts/ResetAdminPassword', obj)
            .then(response => {
              self.showNotification('Password has been reset')
            })
            .catch(error => {
              self.handleError(error)
            }).then(r => {
              self.toggleloader(false)
            })
        })
    },
    ResetEULA () {
      let self = this

      let message = 'Are you sure you would like to reset EULA?'
      let options = {
        html: false, // set to true if your message contains HTML tags. eg: "Delete <b>Foo</b> ?"
        loader: false, // set to true if you want the dailog to show a loader after click on "proceed"
        reverse: false, // switch the button positions (left to right, and vise versa)
        okText: 'Continue',
        cancelText: 'Close',
        animation: 'zoom', // Available: "zoom", "bounce", "fade"
        type: 'basic', // 'basic', // coming soon: 'soft', 'hard'
        verification: 'I know better', // for hard confirm, user will be prompted to type this to enable the proceed button
        verificationHelp: 'Type "[+:verification]" below to confirm', // Verification help text. [+:verification] will be matched with 'options.verification' (i.e 'Type "continue" below to confirm')
        clicksCount: 3, // for soft confirm, user will be asked to click on "proceed" btn 3 times before actually proceeding
        backdropClose: false, // set to true to close the dialog when clicking outside of the dialog window, i.e. click landing on the mask
        customClass: '' // Custom class to be injected into the parent node for the current dialog instance
      }

      let obj = {
        dealershipId: self.account.ID
      }

      self.$dialog.confirm(message, options)
        .then(function () {
          self.toggleloader(true)
          axios.post('/api/accounts/ResetEULA', obj)
            .then(response => {
              self.showNotification('EULA request has been forced')
            })
            .catch(error => {
              self.handleError(error)
            }).then(r => {
              self.toggleloader(false)
            })
        })
    },
    selectAllMakes (SelectAll) {
      var list = []
      this.account.Subscription.MakesSelected = list
      if (SelectAll) {
        this.account.Subscription.Makes.forEach(function (i) {
          if (i.ID !== 0) {
            list.push(i.ID)
          }
        })
      }
    },
    makeselected (e) {
      if (e === 0) {
        // this.selectAllMakes(true);
        this.allMakesSelected = true
      } else {
        this.allMakesSelected = false
      }
    },
    selectAllStates (SelectAll) {
      var list = []
      this.account.Subscription.RegionsSelected = list
      if (SelectAll) {
        this.account.Subscription.Regions.forEach(function (i) {
          list.push(i.ID)
        })
      }
    },
    selectAllLeaseRegions (SelectAll) {
      var list = []
      this.account.Subscription.LeaseLenderRegionsSelected = list
      if (SelectAll) {
        this.account.Subscription.LeaseLenderRegions.forEach(function (i) {
          list.push(i.ID)
        })
      }
    },
    selectAllRetailRegions (SelectAll) {
      var list = []
      this.account.Subscription.RetailLenderRegionsSelected = list
      if (SelectAll) {
        this.account.Subscription.RetailLenderRegions.forEach(function (i) {
          list.push(i.ID)
        })
      }
    },
    getAccountForSave () {
      let self = this
      let str = JSON.stringify(self.account)
      let copyAccount = JSON.parse(str)
      copyAccount.Subscription.Features = copyAccount.Subscription.Features.filter(v => v.IsSelected === true)
      self.SetPropertyBooleanAsText(copyAccount)
      return copyAccount
    },
    SetPropertyBooleanAsText (copyAccount) {
      copyAccount.Subscription.Features.forEach(feature => {
        if (feature.Properties != null) {
          feature.Properties.forEach(property => {
            if (property.Type == 1) {
              if (property.Value !== null) {
                if (property.Value == true) { property.Value = 'True' } else { property.Value = null }
              }
            }
          })
        }
      })
    },
    getNameForEntity (entityName, object) {
      switch (entityName) {
        case 'Makes':
          return object['Name']
        case 'Regions':
          return object['Name']
        case 'LeaseLenderRegions':
          let A = object['Lender']
          let B = object['Region']
          return `${A}: ${B}`
        case 'RetailLenderRegions':
          let C = object['Lender']
          let D = object['Region']
          return `${C}: ${D}`
      }
    },
    getIdFieldForEntity (entityName) {
      switch (entityName) {
        case 'Makes':
          return 'ID'
        case 'Regions':
          return 'ID'
        case 'LeaseLenderRegions':
          return 'ID'
        case 'RetailLenderRegions':
          return 'ID'
      }
    },
    mapPath (path) {
      let self = this

      let original = JSON.parse(JSON.stringify(self.accountOriginal))

      // Subscription -> Features
      var newPath = []

      if (path.length < 3) {
        return path.join(' -> ')
      } else if (path[0] === 'Subscription' && path[1] === 'Features') {
        newPath.splice(0)
        newPath.push(path[0])
        newPath.push(path[1])
        let p2 = original[path[0]][path[1]][path[2]].Name
        newPath.push(p2)
        newPath.push(path[3])
        if (path[3] === 'Properties') {
          let p4 = original[path[0]][path[1]][path[2]][path[3]][path[4]].Name
          newPath.push(p4)
          for (let j = 5; j < path.length; j++) {
            newPath.push(path[j])
          }
        }
        return newPath.join(' -> ')
      } else if (path[0] === 'Subscription' && path[1] === 'InventoryCSVFields') {
        newPath.splice(0)
        newPath.push(path[0])
        newPath.push(path[1])
        let p2 = original[path[0]][path[1]][path[2]].Description
        newPath.push(p2)
        for (let j = 3; j < path.length; j++) {
          newPath.push(path[j])
        }
        return newPath.join(' -> ')
      }
      return path.join(' -> ')
    },
    getDiffArray (differences, isArray) {
      let self = this

      if (differences === undefined || differences === null) {
        return []
      }
      let arrChanges = []
      let count = differences.length

      if (isArray === false) {
        for (let i = 0; i < count; i++) {
          let current = differences[i]

          if (current.constructor.name === 'DiffEdit') {
            let msg = ''
            switch (current.kind) {
              case 'E':
                msg = `[${self.mapPath(current.path)}] changed from: '${current.lhs}' to: '${current.rhs}'`
                arrChanges.push(msg)
                break
                // case 'N':
                //   msg = `${i} Added [${self.mapPath(current.path)}]`
                //   arrChanges.push(msg)
                //   break
                // case 'D':
                //   msg = `${i} Deleted [${self.mapPath(current.path)}] from: '${current.lhs}' to: '${current.rhs}'`
                //   arrChanges.push(msg)
                //   break
                // case 'A':
                //   msg = `${i} Array [${self.mapPath(current.path)}] from: '${current.lhs}' to: '${current.rhs}'`
                //   arrChanges.push(msg)
                //   break
              default:
                msg = `NotArray, DiffEdit unknown operation: ${JSON.stringify(current)}}`
                arrChanges.push(msg)
                break
            }
          } else {
            let msg = `NotArray, DiffArray unknown operation: ${JSON.stringify(current)}}`
            arrChanges.push(msg)
          }
        }
      } else { // isArray === true
        let original = JSON.parse(JSON.stringify(self.accountOriginal))

        for (let i = 0; i < count; i++) {
          let current = differences[i]

          if (current.constructor.name === 'DiffArray') {
            let property = current.path.join('').replace(/Selected/gi, '')

            let idfield = self.getIdFieldForEntity(property)
            let elementName = ''
            let msg = ''
            switch (current.item.kind) {
              case 'N':
                elementName = self.getNameForEntity(property, original['Subscription'][property].find(r => r[idfield] === current.item.rhs))
                msg = `'${elementName}' added to '${property}'`
                arrChanges.push(msg)
                break
              case 'D':
                elementName = self.getNameForEntity(property, original['Subscription'][property].find(r => r[idfield] === current.item.lhs))
                msg = `'${elementName}' deleted from '${property}'`
                arrChanges.push(msg)
                break
              default:
                msg = `Array, DiffArray operation: ${JSON.stringify(current)}}`
                arrChanges.push(msg)
                break
            }
          } else if (current.constructor.name === 'DiffEdit') {
            // we added 1 number and deleted 1 number, so it looks like we adited an element
            // let's cover this specific case here
            let property = current.path[0].replace(/Selected/gi, '')
            let msg = ''
            switch (current.kind) {
              case 'E':
                let idfield = self.getIdFieldForEntity(property)
                let deletedElementName = self.getNameForEntity(property, (original['Subscription'][property]).find(r => r[idfield] === current.lhs))
                let addedElementName = self.getNameForEntity(property, (original['Subscription'][property]).find(r => r[idfield] === current.rhs))

                msg = `'${deletedElementName}' deleted from '${property}'`
                arrChanges.push(msg)

                msg = `'${addedElementName}' added to '${property}'`
                arrChanges.push(msg)
                break
              default:
                msg = `Array, DiffEdit unknown operation: ${JSON.stringify(current)}}`
                arrChanges.push(msg)
                break
            }
          }
        }
      }
      return arrChanges
    },
    GetDiffInformation () {
      let self = this

      let currentMain = JSON.parse(JSON.stringify(self.account))
      let originalMain = JSON.parse(JSON.stringify(self.accountOriginal))

      // console.log(`original swAPIEnv:'${originalMain.swAPIEnv}' BetaEndDate: '${originalMain.BetaEndDate}'`)
      // console.log(`current swAPIEnv:'${currentMain.swAPIEnv}' BetaEndDate: '${currentMain.BetaEndDate}'`)

      let currentSubs = {
        LeaseLenderRegions: JSON.parse(JSON.stringify(self.account['Subscription']['LeaseLenderRegions'])),
        LeaseLenderRegionsSelected: JSON.parse(JSON.stringify(self.account['Subscription']['LeaseLenderRegionsSelected'])),

        Makes: JSON.parse(JSON.stringify(self.account['Subscription']['Makes'])),
        MakesSelected: JSON.parse(JSON.stringify(self.account['Subscription']['MakesSelected'])),

        Regions: JSON.parse(JSON.stringify(self.account['Subscription']['Regions'])),
        RegionsSelected: JSON.parse(JSON.stringify(self.account['Subscription']['RegionsSelected'])),

        RetailLenderRegions: JSON.parse(JSON.stringify(self.account['Subscription']['RetailLenderRegions'])),
        RetailLenderRegionsSelected: JSON.parse(JSON.stringify(self.account['Subscription']['RetailLenderRegionsSelected']))
      }

      let originalSubs = {
        LeaseLenderRegions: JSON.parse(JSON.stringify(self.accountOriginal['Subscription']['LeaseLenderRegions'])),
        LeaseLenderRegionsSelected: JSON.parse(JSON.stringify(self.accountOriginal['Subscription']['LeaseLenderRegionsSelected'])),

        Makes: JSON.parse(JSON.stringify(self.accountOriginal['Subscription']['Makes'])),
        MakesSelected: JSON.parse(JSON.stringify(self.accountOriginal['Subscription']['MakesSelected'])),

        Regions: JSON.parse(JSON.stringify(self.accountOriginal['Subscription']['Regions'])),
        RegionsSelected: JSON.parse(JSON.stringify(self.accountOriginal['Subscription']['RegionsSelected'])),

        RetailLenderRegions: JSON.parse(JSON.stringify(self.accountOriginal['Subscription']['RetailLenderRegions'])),
        RetailLenderRegionsSelected: JSON.parse(JSON.stringify(self.accountOriginal['Subscription']['RetailLenderRegionsSelected']))
      }

      delete currentMain['Subscription']['LeaseLenderRegions']
      delete currentMain['Subscription']['LeaseLenderRegionsSelected']

      delete currentMain['Subscription']['Makes']
      delete currentMain['Subscription']['MakesSelected']

      delete currentMain['Subscription']['Regions']
      delete currentMain['Subscription']['RegionsSelected']

      delete currentMain['Subscription']['RetailLenderRegions']
      delete currentMain['Subscription']['RetailLenderRegionsSelected']

      delete originalMain['Subscription']['LeaseLenderRegions']
      delete originalMain['Subscription']['LeaseLenderRegionsSelected']

      delete originalMain['Subscription']['Makes']
      delete originalMain['Subscription']['MakesSelected']

      delete originalMain['Subscription']['Regions']
      delete originalMain['Subscription']['RegionsSelected']

      delete originalMain['Subscription']['RetailLenderRegions']
      delete originalMain['Subscription']['RetailLenderRegionsSelected']

      let mainDiff = deepdiff(originalMain, currentMain)
      let mainArr = self.getDiffArray(mainDiff, false)

      let subDiff = deepdiff(originalSubs, currentSubs)
      let subArr = self.getDiffArray(subDiff, true)

      let count = subArr.length
      for (let i = 0; i < count; i++) {
        for (let j = 0; j < count; j++) {
          if (i !== j && self.IsAnnihilationLogEntry(subArr[i], subArr[j])) {
            subArr[i] = undefined
            subArr[j] = undefined
          }
        }
      }
      subArr = subArr.filter(r => r !== undefined)

      return mainArr.concat(subArr)
    },
    /**
         * @return {boolean}
         */
    IsAnnihilationLogEntry (A, B) {
      if (A === undefined || B === undefined) {
        return false
      }
      let a = (JSON.parse(JSON.stringify(A)) + '').toLowerCase()
      let b = (JSON.parse(JSON.stringify(B)) + '').toLowerCase()

      let patArr = ['deleted', 'from', 'added', 'to', ' ']
      let count = patArr.length
      for (let k = 0; k < count; k++) {
        let pattern = new RegExp(patArr[k], 'gi')
        a = a.replace(pattern, '')
        b = b.replace(pattern, '')
      }
      return a === b
    },
    saveAccount () {
      let self = this
      self.invalidAddress = false

      if (!self.saveAccountAddressValidation()) { return }
      self.$validator.validate().then(valid => {
        if (valid) {
          let diffText = self.GetDiffInformation()

          if (diffText !== undefined && diffText.length > 0) {
            self.toggleloader(true)

            let obj = {
              account: self.getAccountForSave(),
              MESSAGE: diffText
            }

            axios.post('/api/accounts/saveaccount', obj)
              .then(() => {
                self.showNotification('Account Saved')
                self.fetchData()
                self.toggleloader(false)
              })
              .catch(error => {
                if (error.response.data.includes('address')) {
                  self.invalidAddress = true
                }
                self.handleError(error)
                self.toggleloader(false)
              })
          } else {
            self.showInformation('There is nothing to save')
          }
        } else {
          self.showInformation('Please fix validation errors')
        }

        if (!self.isEnterpriseEnabled) {
          self.deleteEnterprise()
        } else if (self.isEnterpriseEnabled && self.enterpriseId !== '') {
          self.addEnterprise()
        }
      })
    },
    getDealershipNotes () {
      let self = this
      let obj = {
        AccountNumber: self.accountOriginal.AccountNumber || '',
        Keyword: self.Keyword || '',
        Limit: 5
      }
      axios.post('/api/accounts/getdealershipnotes', obj)
        .then(response => {
          let notes = response.data
          self.notes = notes
        })
        .catch(error => {
          self.handleError(error)
        }).then(r => {
          self.toggleloader(false)
        })
    },
    saveDealershipNotes () {
      let self = this
      if (self.txtNote.length > 0) {
        let obj = {
          AccountNumber: self.accountOriginal.AccountNumber || '',
          Description: self.txtNote || ''
        }
        axios.post('/api/accounts/savedealershipnote', obj)
          .then(response => {
            let res = response.data
            self.showNotification('Note saved')
            self.getDealershipNotes()
            self.txtNote = ''
          })
          .catch(error => {
            self.handleError(error)
          }).then(r => {
            self.toggleloader(false)
          })
      } else {
        alert('The note is empty!')
      }
    },
    pin (DealershipNoteId) {
      let self = this
      let obj = {
        DealershipNoteId: DealershipNoteId
      }
      axios.post('/api/accounts/dealershipnotes_pin', obj)
        .then(response => {
          let res = response.data
          self.showNotification('Note saved')
          self.getDealershipNotes()
        })
        .catch(error => {
          self.handleError(error)
        }).then(r => {
          self.toggleloader(false)
        })
    },
    unpin (DealershipNoteId) {
      let self = this
      let obj = {
        DealershipNoteId: DealershipNoteId
      }
      axios.post('/api/accounts/dealershipnotes_unpin', obj)
        .then(response => {
          let res = response.data
          self.showNotification('Note saved')
          self.getDealershipNotes()
        })
        .catch(error => {
          self.handleError(error)
        }).then(r => {
          self.toggleloader(false)
        })
    },
    ClearSearch () {
      let self = this
      self.Keyword = ''
    },
    DeleteInventory () {
      let self = this
      let obj = {
        DealershipID: self.account.ID
      }
      let deletedInventory = ''

      let message = 'Are you sure you want to delete all inventory records for this account?'
      let options = {
        html: false, // set to true if your message contains HTML tags. eg: "Delete <b>Foo</b> ?"
        loader: false, // set to true if you want the dailog to show a loader after click on "proceed"
        reverse: false, // switch the button positions (left to right, and vise versa)
        okText: 'Continue',
        cancelText: 'Close',
        animation: 'zoom', // Available: "zoom", "bounce", "fade"
        type: 'soft', // 'basic', // coming soon: 'soft', 'hard'
        verification: 'I know better', // for hard confirm, user will be prompted to type this to enable the proceed button
        verificationHelp: 'Type "[+:verification]" below to confirm', // Verification help text. [+:verification] will be matched with 'options.verification' (i.e 'Type "continue" below to confirm')
        clicksCount: 3, // for soft confirm, user will be asked to click on "proceed" btn 3 times before actually proceeding
        backdropClose: false, // set to true to close the dialog when clicking outside of the dialog window, i.e. click landing on the mask
        customClass: '' // Custom class to be injected into the parent node for the current dialog instance
      }
      self.$dialog.confirm(message, options)
        .then(function () {
          axios.post('/api/accounts/DeleteInventory', obj)
            .then(response => {
              deletedInventory = response.data
              if (deletedInventory != '') {
                var count = (deletedInventory.match(/,/g) || []).length
                self.showNotification((count + 1) + ' row(s) of inventory have been deleted')
                self.SaveAudit(`[    "[Inventory] Deleted: ${deletedInventory}" ]`)
              } else {
                self.showNotification('There are no inventory records to delete for this account')
              }
            })
            .catch(error => {
              self.handleError(error)
            }).then(r => {
              self.toggleloader(false)
            })
        })
    },
    SaveAudit (message) {
      let self = this
      let obj2 = {
        account: self.account.AccountNumber,
        DealershipID: self.account.ID,
        MESSAGE: message
      }

      axios.post('/api/accounts/addaudit', obj2)
        .then(response => {
        })
        .catch(error => {
          self.handleError(error)
        }).then(r => {
          self.toggleloader(false)
        })
    },
    CreatePrimaryAccount () {
      let self = this

      let old = 'null'
      if (self.account.PrimaryAccount !== null && self.account.PrimaryAccount !== undefined) {
        old = self.account.PrimaryAccount.AccountNumber
      }

      let obj = {
        dealershipid: self.account.ID,
        AccountNumber: self.account.AccountNumber,
        PrimaryAccount: old
      }

      let message = 'Are you sure you want to create a new primary account for this account?'
      let options = {
        html: false, // set to true if your message contains HTML tags. eg: "Delete <b>Foo</b> ?"
        loader: false, // set to true if you want the dailog to show a loader after click on "proceed"
        reverse: false, // switch the button positions (left to right, and vise versa)
        okText: 'Continue',
        cancelText: 'Close',
        animation: 'zoom', // Available: "zoom", "bounce", "fade"
        type: 'soft', // 'basic', // coming soon: 'soft', 'hard'
        verification: 'I know better', // for hard confirm, user will be prompted to type this to enable the proceed button
        verificationHelp: 'Type "[+:verification]" below to confirm', // Verification help text. [+:verification] will be matched with 'options.verification' (i.e 'Type "continue" below to confirm')
        clicksCount: 3, // for soft confirm, user will be asked to click on "proceed" btn 3 times before actually proceeding
        backdropClose: false, // set to true to close the dialog when clicking outside of the dialog window, i.e. click landing on the mask
        customClass: '' // Custom class to be injected into the parent node for the current dialog instance
      }
      self.$dialog.confirm(message, options)
        .then(function () {
          axios.post('/api/accounts/createprimaryaccount', obj)
            .then(response => {
              self.account.PrimaryAccount.AccountNumber = response.data.account
              self.account.PrimaryAccount.ID = response.data.dealershipId
              self.showNotification(`Primary account changed to ${response.data.account} from ${old}`)
            })
            .catch(error => {
              self.handleError(error)
            }).then(r => {
              self.toggleloader(false)
            })
        })
    },
    Cancel () {
      let self = this
      self.$dialog.confirm('Are you sure you would like to cancel your changes?')
        .then(function () {
          self.$router.push('/accounts')
        })
        .catch(function () {
          // do nothing
        })
    },
    DeleteAllPopUps () {
      let self = this
      let obj = {
        AccountNumber: self.account.AccountNumber,
        DealershipID: self.account.Subscription.DealershipID,
        Data: []
      }
      self.receivedDeals.forEach(UserID => {
        obj.Data.push({ User_ID: UserID.UserID, mQEvent_ID: UserID.mQEventID})
      })
      // console.log(obj)
      axios.post('/api/accounts/ClearmQEvents', obj)
        .then(response => {
          let res = response.data

          self.fetchReceivedDeals()
        })
        .catch(error => {
          self.handleError(error)
        }).then(r => {
          self.toggleloader(false)
        })
    },
    DeletePopUp (User_ID, mQEvent_ID) {
      let self = this
      let obj = {
        AccountNumber: self.accountOriginal.AccountNumber,
        DealershipID: self.account.Subscription.DealershipID,
        Data: [{ User_ID, mQEvent_ID }]
      }
      // console.log(obj)
      axios.post('/api/accounts/ClearmQEvents', obj)
        .then(response => {
          let res = response.data

          self.fetchReceivedDeals()
        })
        .catch(error => {
          self.handleError(error)
        }).then(r => {
          self.toggleloader(false)
        })
    },
    selectCountryCode (option) {
      this.account.State = undefined
      this.countryCode = option
      this.account.Country = parseInt(this.countryCode.value)
    },
    saveAccountAddressValidation () {
      let self = this
      let warningArr = []

      if (!self.HasValue(self.account.Name)) {
        warningArr.push('Name')
      }
      if (!self.HasValue(self.account.Address)) {
        warningArr.push('Address')
      }
      if (!self.HasValue(self.account.City)) {
        warningArr.push('City')
      }
      if (self.countryCode.value === '1') {
        if (!self.HasValue(self.account.State)) {
          warningArr.push('State')
        }
      } else {
        if (!self.HasValue(self.account.State)) {
          warningArr.push('Province')
        }
      }
      if (!self.HasValue(self.account.Zip)) {
        if (self.countryCode.value === '1') {
          warningArr.push('Zip Code')
        } else {
          warningArr.push('Postal Code')
        }
      }
      if (self.countryCode.value === '1' && isNaN(self.account.Zip)) {
        warningArr.push('Zip Code must be valid zip code for country USA')
      }
      if (warningArr.length > 0) {
        self.showInformation(`Required field(s): ${warningArr.join(', ')}`)
        return false
      }
      return true
    },
    HasValue (val) {
      return val !== undefined && val !== null && val !== ''
    },
    OnImportModalCancel () {
      this.$refs['dmsImportAccountModal'].hide()
      this.dmsAccountIdImportInput = null
      this.dmsModalError = null
    },
    OnImportDMSKeydown (event) {
      if (event.which === 13) {
        // The key pressed was the enter key
        this.ImportDMSMappingsFromAccountId()
      }
    },
    async ImportDMSMappingsFromAccountId () {
      this.dmsModalError = null
      this.toggleloader(true)

      var importAccount = await axios.get('/api/accounts/loadaccount?a=' + this.dmsAccountIdImportInput)

      if (!importAccount || !importAccount.data) {
        this.dmsModalError = 'Account not found'
        this.toggleloader(false)

        return
      }

      var importAccountInventoryCSVFields = importAccount.data.Subscription.InventoryCSVFields

      if (!importAccountInventoryCSVFields || importAccountInventoryCSVFields.length <= 0) {
        this.dmsModalError = 'Account contains no inventory csv data'
        this.toggleloader(false)

        return
      }

      // replace current account csv fields with the ones from import account
      this.account.Subscription.InventoryCSVFields.forEach(x => {
        var importCSVField = importAccountInventoryCSVFields.find(y => y.ID == x.ID)

        if (importCSVField) {
          Object.assign(x, importCSVField)
        }
      })

      this.toggleloader(false)
      this.OnImportModalCancel()
    }
  },
  computed: {
    AccountStatus: {
      get: function () {
        let self = this
        return self.account.mScanAPIStatus
      },
      set: function (newValue) {
        let self = this
        self.account.mScanAPIStatus = Number(newValue)
        if (newValue === 1) {
          self.account.BetaEndDate = new Date()
        } else {
          self.account.BetaEndDate = null
        }
      }
    },
    accountName: function () {
      let self = this
      return (self.account !== undefined && self.account !== null) ? self.account.Name : ''
    },
    accountNumber: function () {
      let self = this
      return (self.account !== undefined && self.account !== null) ? self.account.AccountNumber : ''
    },
    IsCanada: function () {
      const self = this
      if (self.account.Country === 2) {
        return true
      } else if (self.account.Country === 1) {
        return false
      } else if (self.account.Country === 0 && self.account.State !== undefined && self.account.State !== null && self.account.State !== '') {
        return self.provinceOptionsArray.filter(x => x.Code === self.account.State).length > 0
      }
      return false
    },
    IsCanadaProvince: function () {
      const self = this
      if (self.account.State !== undefined && self.account.State !== null && self.account.State !== '') {
        return self.provinceOptionsArray.filter(x => x.Code === self.account.State).length > 0
      }
      if (self.account.Country === 2) {
        return true
      }
      return false
    },
    IsEditAccountNumButtDisabled: function () {
      if (!this.account)
        return false;

      return this.updatedAccountNum === this.account.AccountNumber;
    },
    DealershipLinkSubscriptionType: () => DealershipLinkSubscriptionType
  }
}</script>

<style scoped>
  #accDisabled .dx-switch-off {
    padding-left: 2px;
    color: #3a9d5d;
  }

  #accDisabled .dx-switch-on {
    padding-left: 2px;
    color: #ff0000;
  }

  .close-modal {
    position: absolute;
    top: 10px;
    right: 15px;
    cursor: pointer;
  }

  .hidden_header {
    display: none;
  }

  .table-features > tbody > tr > td,
  .table-features > tbody > tr > th {
    border: 0;
    background-color: white;
    padding: 1px;
  }
  .btn {
    min-width: 200px !important;
  }

  .created_ts_column_css {
    width: 150px;
  }

  .dealership_id_column_css {
    width: 40px;
  }

  .create_by_column_css {
    width: 150px;
  }

  .description_column_css {
  }

  .pin_by_column_css {
    width: 30px;
  }

  .minWidthFeatureLabel {
    min-width: 90px;
  }

  .btn-small {
    min-width: 150px;
  }

  .btn-smaller {
    min-width: 80px;
  }

  .flagImage {
    width: 25px;
    height: 25px;
  }

  .accountEdit{
    position: relative;
    top:5px;
    cursor: pointer;
  }
  .errMsg {
    color:red;
  }
  /*
    .btn-outline-secondary:not(:disabled):not(.disabled):active, .btn-outline-secondary:not(:disabled):not(.disabled).active, .show > .btn-outline-secondary.dropdown-toggle, .show > .btn-outline-secondary.dropdown-toggle-no-caret {
    color: #000000 !important;
    background-color:  #FFFFFF !important;
  }
   */
  .manage-links {
    margin-bottom: 1.25rem;
  }
  .vertical-center {
    display: flex;
    align-items: center;
  }
  .dms-modal-btn-container{
    display: flex;
    justify-content: flex-end;
    margin-top: 12px;
  }
  .modal-import-btn {
    min-width: initial !important;
    margin-right: 12px;
  }
  .modal-cancel-btn {
    min-width: initial !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/AccountDetail.vue